import axios from 'axios';
import { baseUrl, HttpMethods } from '@/api/base';
import type { GetProjectAuditsParams, GetProjectAuditsResponse } from './types';

export async function getProjectAudits(params: GetProjectAuditsParams): Promise<GetProjectAuditsResponse> {
  const response = await axios.request<GetProjectAuditsResponse>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/audits`,
    params,
  });

  return response.data;
}
